
import { Answer } from "@/entities/domain/Quiz/Answer";
import Company from "@/entities/domain/Company/Company";
import { defineComponent, PropType } from "vue";

export default defineComponent({
	name: "NumberInput",
	props: {
		company: {
			type: Object as PropType<Company>,
		},
	},
	emits: ["answerClicked"],
	data: () => ({
		numberInput: undefined as string | number | string[] | undefined,
	}),
	computed: {
		answers(): Answer[] {
			return this.company?.Quiz.getCurrentQuestion().Answers ?? [];
		},
	},
	mounted() {
		(this.$refs.numberInput as any).focus();
	},
	methods: {
		setAnswer() {
			let answerToSet;

			this.answers.forEach((answer) => {
				if (this.numberInput && answer.Text && eval(this.numberInput + answer.Text)) {
					answerToSet = answer;
				}
			});

			this.$emit("answerClicked", {
				answerId: answerToSet.id,
				answerValue: this.numberInput,
			});
		},
	},
});
